import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TextField from "@mui/material/TextField";
import { ThemeProvider } from '@mui/styles';
import dayjs from 'dayjs';
import React, { Component } from 'react';
import NumberFormat from 'react-number-format';
import { Link } from 'react-router-dom';
import Select from "react-select";
import { BlueButton } from "../components/BlueButton";
import { GetToken, GuestLogin, Me, RefreshSession, SetToken, SetUser } from "../services/Session";
import { GetOrderSummaries, GetProductSold, GetXlsxOrderDetails } from '../services/Transaction';
import '../styles/style.css';
import theme from '../styles/theme';

const BackIcon = '/assets/svg/back.svg'
const FilterIcon = "/assets/svg/filter.svg";

class Dashboard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoadingXlsx: false,
			isOpenFilter: false,
			startDate: "",
			endDate: "",
			raw_type_filter: [],
			raw_status_filter: [{ value: "paid", label: "Lunas" }],
			filters: {
				"status.$in": "paid",
			},
			results: [],
			order_summary: {
				count: 0,
				delivery_cost: 0,
				amount: 0,
			}
		};
	}

	componentDidMount = () => {
		this.handleGetData()
	}

	handleGetData = () => {
		GetOrderSummaries(this.state.filters).then(res => {
			this.setState({ order_summary: res.data })
		}).catch(err => {
			if (err.response) {
				if (err.response && err.response.status === 401) {
					if (GetToken().refresh_token !== null) {
						RefreshSession(GetToken().refresh_token)
					} else {
						this.handleLogout()
					}
				}
			}
		})
		GetProductSold(this.state.filters).then(res => {
			this.setState({ results: res.data.results })
		}).catch(err => {
			if (err.response) {
				if (err.response && err.response.status === 401) {
					if (GetToken().refresh_token !== null) {
						RefreshSession(GetToken().refresh_token)
					} else {
						this.handleLogout()
					}
				}
			}
		})
	}
	handleXlsx = () => {
		this.setState({ isLoadingXlsx: true })
		GetXlsxOrderDetails(this.state.filters).then(res => {
			this.setState({ isLoadingXlsx: false })
			const downloadUrl = window.URL.createObjectURL(res.data);
			const link = document.createElement('a');
			link.href = downloadUrl;
			link.setAttribute('download', 'orders-' + dayjs().format('YYYY-MM-DD_HH.mm') + '.xlsx');
			document.body.appendChild(link);
			link.click();
			link.remove();
		}).catch(err => {
			this.setState({ isLoadingXlsx: false })
			if (err.response) {
				if (err.response && err.response.status === 401) {
					if (GetToken().refresh_token !== null) {
						RefreshSession(GetToken().refresh_token)
					} else {
						this.handleLogout()
					}
				}
			}
		})
	}

	handleLogout = () => {
		GuestLogin().then(res => {
			Me(SetToken(res.data.token).access_token).then(res => {
				SetUser(res.data);
				setTimeout(this.props.history.push("/"), 3000);
			});
		});
	};

	openFilter = () => {
		this.setState({ isOpenFilter: true });
	};

	closeFilter = () => {
		this.setState({ isOpenFilter: false });
	};

	resetFilter = () => {
		this.setState({
			startDate: "",
			endDate: "",
			raw_type_filter: [],
			raw_status_filter: [{ value: "paid", label: "Lunas" }],
			filters: {
				"status.$in": "paid",
			},
		});
	};

	applyFilter = () => {
		this.setState({
			isOpenFilter: false
		});

		this.handleGetData();
	}

	handleChangeFilterOption = (selectedOptions, filtername) => {
		if (filtername === 'type' || filtername === 'status') {
			const selected = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
			const fRaw = (filtername === 'type') ? 'raw_type_filter' : 'raw_status_filter';
			const fName = (filtername === 'type') ? 'type.$in' : 'status.$in';
			this.setState({
				[fRaw]: selectedOptions,
				filters: {
					...this.state.filters,
					[fName]: selected.toString()
				}
			})
		} else if (filtername === 'created_at.$gte' || filtername === 'created_at.$lt' || filtername === 'payment.paid_at.$gte' || filtername === 'payment.paid_at.$lt') {
			const fValue = (filtername === 'created_at.$gte' || filtername === 'payment.paid_at.$gte') ? selectedOptions.target.value : dayjs(selectedOptions.target.value).add(1, 'days').format('YYYY-MM-DD');
			this.setState({
				[filtername]: selectedOptions.target.value,
				filters: {
					...this.state.filters,
					[filtername]: fValue,
				}
			})
		} else if (filtername === 'sort') {
			this.setState({
				raw_sort_filter: selectedOptions,
				filters: {
					...this.state.filters,
					sorts: selectedOptions.value
				}
			})
		} else {
			this.setState({
				[filtername]: selectedOptions.target.value,
				filters: {
					...this.state.filters,
					[filtername]: '%' + selectedOptions.target.value + '%',
				}
			})
		}
	}

	filterDialog = () => {
		const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) }
		return (
			<Dialog
				open={this.state.isOpenFilter}
				onClose={this.closeFilter}
				aria-labelledby="form-dialog-title"
				className="dialog-filter"
				style={{ height: "100%" }}
			>
				<DialogTitle id="form-dialog-title">Filter</DialogTitle>
				<DialogContent>
					<div className="center" style={{ width: 240, paddingTop: 0, paddingBottom: 10, fontFamily: 'Open Sans' }}>
						<Select
							styles={selectStyles}
							isMulti
							placeholder="Tipe"
							isSearchable={true}
							value={this.state.raw_type_filter}
							onChange={(opt) => this.handleChangeFilterOption(opt, 'type')}
							options={[
								{ value: "certificate", label: "Syahadah" },
								{ value: "pre_order", label: "Pre Order" },
								{ value: "ready_stock", label: "Ready Stock" },
								{ value: "ticket", label: "e-Ticket" },
							]}
						/>
					</div>
					<div
						className="center"
						style={{ width: 240, paddingTop: 10, paddingBottom: 10, fontFamily: 'Open Sans' }}
					>
						<Select
							styles={selectStyles}
							isMulti
							placeholder="Status"
							isSearchable={true}
							value={this.state.raw_status_filter}
							onChange={(opt) => this.handleChangeFilterOption(opt, 'status')}
							options={[
								{ value: "paid", label: "Lunas" },
								{ value: "awaiting_payment", label: "Menunggu Pembayaran" },
								{ value: "expired", label: "Kedaluwarsa" },
								{ value: "canceled", label: "Dibatalkan" },
								{ value: "rejected", label: "Ditolak" },
								{ value: "refunded", label: "Dikembalikan" },
								{ value: "packing", label: "Diproses" },
								{ value: "shipped", label: "Dikirim" },
								{ value: "delivered", label: "Sampai Tujuan" },
							]}
						/>
					</div>
					<div className="center" style={{ width: 240, paddingTop: 0, paddingBottom: 10, fontFamily: 'Open Sans' }}>
						<div style={{ paddingTop: 10, paddingBottom: 10 }}>Tanggal Buat</div>
						<TextField
							label="Dari"
							type="date"
							defaultValue={this.state['created_at.$gte']}
							onChange={(opt) => this.handleChangeFilterOption(opt, 'created_at.$gte')}
							size="small"
							variant="outlined"
							style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 10, marginBottom: 10 }}
							InputLabelProps={{
								shrink: true,
							}}
						/>
						<TextField
							label="Hingga"
							type="date"
							defaultValue={this.state['created_at.$lt']}
							onChange={(opt) => this.handleChangeFilterOption(opt, 'created_at.$lt')}
							size="small"
							variant="outlined"
							style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 10 }}
							InputLabelProps={{
								shrink: true,
							}}
						/>
						<div style={{ paddingTop: 10, paddingBottom: 10 }}>Tanggal Bayar</div>
						<TextField
							label="Dari"
							type="date"
							defaultValue={this.state['payment.paid_at.$gte']}
							onChange={(opt) => this.handleChangeFilterOption(opt, 'payment.paid_at.$gte')}
							size="small"
							variant="outlined"
							style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 10, marginBottom: 10 }}
							InputLabelProps={{
								shrink: true,
							}}
						/>
						<TextField
							label="Hingga"
							type="date"
							defaultValue={this.state['payment.paid_at.$lt']}
							onChange={(opt) => this.handleChangeFilterOption(opt, 'payment.paid_at.$lt')}
							size="small"
							variant="outlined"
							style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 10 }}
							InputLabelProps={{
								shrink: true,
							}}
						/>
					</div>
					<div className="center" style={{ width: 240, paddingTop: 0, paddingBottom: 10, fontFamily: 'Open Sans' }}>
						<TextField
							label="Nama Produk"
							defaultValue={this.state['catalog.name.$ilike']}
							onChange={(opt) => this.handleChangeFilterOption(opt, 'catalog.name.$ilike')}
							size="small"
							variant="outlined"
							style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 20, marginBottom: 10 }}
						/>
						<TextField
							label="Nama Pelanggan"
							defaultValue={this.state['customer.name.$ilike']}
							onChange={(opt) => this.handleChangeFilterOption(opt, 'customer.name.$ilike')}
							size="small"
							variant="outlined"
							style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 20, marginBottom: 10 }}
						/>
						<TextField
							label="Nomor Whatsapp"
							defaultValue={this.state['customer.phone.$ilike']}
							onChange={(opt) => this.handleChangeFilterOption(opt, 'customer.phone.$ilike')}
							size="small"
							variant="outlined"
							style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 20, marginBottom: 10 }}
						/>
						<TextField
							label="Email"
							defaultValue={this.state['customer.email.$ilike']}
							onChange={(opt) => this.handleChangeFilterOption(opt, 'customer.email.$ilike')}
							size="small"
							variant="outlined"
							style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 20, marginBottom: 10 }}
						/>
						<TextField
							label="Virtual Account"
							defaultValue={this.state['customer.virtual_account.$ilike']}
							onChange={(opt) => this.handleChangeFilterOption(opt, 'customer.virtual_account.$ilike')}
							size="small"
							variant="outlined"
							style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 20, marginBottom: 10 }}
						/>
						<TextField
							label="Kurir"
							defaultValue={this.state['delivery_service.courier_service.name.$ilike']}
							onChange={(opt) => this.handleChangeFilterOption(opt, 'delivery_service.courier_service.name.$ilike')}
							size="small"
							variant="outlined"
							style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 20, marginBottom: 10 }}
						/>
						<TextField
							label="Nama Penerima"
							defaultValue={this.state['delivery_service.destination_address.contact_person.$ilike']}
							onChange={(opt) => this.handleChangeFilterOption(opt, 'delivery_service.destination_address.contact_person.$ilike')}
							size="small"
							variant="outlined"
							style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 20, marginBottom: 10 }}
						/>
						<TextField
							label="Nomor HP Penerima"
							defaultValue={this.state['delivery_service.destination_address.phone.$ilike']}
							onChange={(opt) => this.handleChangeFilterOption(opt, 'delivery_service.destination_address.phone.$ilike')}
							size="small"
							variant="outlined"
							style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 20, marginBottom: 10 }}
						/>
						<TextField
							label="Alamat Pengiriman"
							defaultValue={this.state['delivery_service.destination_address.complete.$ilike']}
							onChange={(opt) => this.handleChangeFilterOption(opt, 'delivery_service.destination_address.complete.$ilike')}
							size="small"
							variant="outlined"
							style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 10 }}
						/>
					</div>
					<div
						className="center"
						style={{ width: 240, paddingTop: 0, paddingBottom: 100, fontFamily: 'Open Sans' }}
					>
						<Select
							styles={selectStyles}
							placeholder="Urutkan dari yang"
							value={this.state.raw_sort_filter}
							onChange={(opt) => this.handleChangeFilterOption(opt, 'sort')}
							options={[
								{ value: "-created_at", label: "Terbaru" },
								{ value: "created_at", label: "Terlama" },
							]}
						/>
					</div>
				</DialogContent>
				<DialogActions>
					<Button onClick={this.resetFilter} color="primary">
						Atur Ulang
					</Button>
					<Button onClick={this.applyFilter} color="primary">
						Terapkan
					</Button>
				</DialogActions>
			</Dialog>
		);
	};

	render() {
		let total_available = 0;
		let total_awaiting_payment = 0;
		let total_canceled = 0;
		let total_expired = 0;
		let total_paid = 0;
		let total_shipped = 0;
		let total_delivered = 0;
		let total_awaiting_payment_amount = 0;
		let total_canceled_amount = 0;
		let total_expired_amount = 0;
		let total_paid_amount = 0;
		let total_shipped_amount = 0;
		let total_delivered_amount = 0;

		return (
			<ThemeProvider theme={theme}>
				<div style={{ position: 'relative', maxWidth: '60rem', margin: 'auto' }}>
					<div className="header">
						<Link to="/" style={{ position: "absolute", height: 60, width: 60, top: 0, left: 0 }}>
							<img alt="icon" src={BackIcon} />
						</Link>
						<div className="center" style={{ marginTop: 20 }}>
							<h3 className="title">Dasbor</h3>
						</div>
						<div style={{ position: "absolute", height: 24, width: 60, top: 18, right: 10, cursor: 'pointer' }}>
							<img alt="icon" src={FilterIcon} onClick={this.openFilter} />
						</div>
					</div>
					<div className="wrapper">
						{this.filterDialog()}
						<div style={{ padding: 10 }}>
							<TableContainer component={Paper}>
								<Table>
									<TableBody>
										<TableRow><TableCell>Jumlah Transaksi</TableCell><TableCell align="right"><NumberFormat value={this.state.order_summary.count} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></TableCell></TableRow>
										<TableRow><TableCell>Subtotal</TableCell><TableCell align="right"><NumberFormat value={this.state.order_summary.amount - this.state.order_summary.delivery_cost + this.state.order_summary.discount} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></TableCell></TableRow>
										<TableRow><TableCell>Biaya Pengiriman</TableCell><TableCell align="right"><NumberFormat value={this.state.order_summary.delivery_cost} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></TableCell></TableRow>
										<TableRow><TableCell>Diskon</TableCell><TableCell align="right">- <NumberFormat value={this.state.order_summary.discount} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></TableCell></TableRow>
										<TableRow><TableCell>Total Penjualan</TableCell><TableCell align="right"><NumberFormat value={this.state.order_summary.amount} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></TableCell></TableRow>
									</TableBody>
								</Table>
							</TableContainer>
						</div>
						<div style={{ padding: 10 }}>
							<TableContainer component={Paper}>
								<Table>
									<TableHead>
										<TableRow>
											<TableCell>Product</TableCell>
											<TableCell align="right">Available Stock</TableCell>
											<TableCell align="right">Awaiting Payment</TableCell>
											<TableCell align="right">Canceled</TableCell>
											<TableCell align="right">Expired</TableCell>
											<TableCell align="right">Paid</TableCell>
											<TableCell align="right">Shipped</TableCell>
											<TableCell align="right">Delivered</TableCell>
											<TableCell align="right">Total</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{(this.state.results && this.state.results.length > 0) && this.state.results.map((product, index) => {
											let qty_available = product?.quantity?.available ?? 0;
											let qty_awaiting_payment = product?.sold?.awaiting_payment?.quantity ?? 0;
											let qty_canceled = product?.sold?.canceled?.quantity ?? 0;
											let qty_expired = product?.sold?.expired?.quantity ?? 0;
											let qty_paid = product?.sold?.paid?.quantity ?? 0;
											let qty_shipped = product?.sold?.shipped?.quantity ?? 0;
											let qty_delivered = product?.sold?.delivered?.quantity ?? 0;
											total_available += qty_available;
											total_awaiting_payment += qty_awaiting_payment;
											total_canceled += qty_canceled;
											total_expired += qty_expired;
											total_paid += qty_paid;
											total_shipped += qty_shipped;
											total_delivered += qty_delivered;
											return (
												<TableRow>
													<TableCell>{product.code}</TableCell>
													<TableCell align="right"><NumberFormat value={qty_available} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></TableCell>
													<TableCell align="right"><NumberFormat value={qty_awaiting_payment} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></TableCell>
													<TableCell align="right"><NumberFormat value={qty_canceled} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></TableCell>
													<TableCell align="right"><NumberFormat value={qty_expired} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></TableCell>
													<TableCell align="right"><NumberFormat value={qty_paid} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></TableCell>
													<TableCell align="right"><NumberFormat value={qty_shipped} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></TableCell>
													<TableCell align="right"><NumberFormat value={qty_delivered} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></TableCell>
													<TableCell align="right"><NumberFormat value={qty_awaiting_payment + qty_canceled + qty_expired + qty_paid + qty_shipped + qty_delivered} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></TableCell>
												</TableRow>
											)
										})}
										<TableRow>
											<TableCell><b>Grand Total</b></TableCell>
											<TableCell align="right"><b><NumberFormat value={total_available} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></b></TableCell>
											<TableCell align="right"><b><NumberFormat value={total_awaiting_payment} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></b></TableCell>
											<TableCell align="right"><b><NumberFormat value={total_canceled} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></b></TableCell>
											<TableCell align="right"><b><NumberFormat value={total_expired} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></b></TableCell>
											<TableCell align="right"><b><NumberFormat value={total_paid} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></b></TableCell>
											<TableCell align="right"><b><NumberFormat value={total_shipped} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></b></TableCell>
											<TableCell align="right"><b><NumberFormat value={total_delivered} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></b></TableCell>
											<TableCell align="right"><b><NumberFormat value={total_awaiting_payment + total_canceled + total_expired + total_paid + total_shipped + total_delivered} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></b></TableCell>
										</TableRow>
									</TableBody>
								</Table>
							</TableContainer>
						</div>
						<div style={{ padding: 10 }}>
							<TableContainer component={Paper}>
								<Table>
									<TableHead>
										<TableRow>
											<TableCell>Product</TableCell>
											<TableCell align="right">Unit Price</TableCell>
											<TableCell align="right">Awaiting Payment</TableCell>
											<TableCell align="right">Canceled</TableCell>
											<TableCell align="right">Expired</TableCell>
											<TableCell align="right">Paid</TableCell>
											<TableCell align="right">Shipped</TableCell>
											<TableCell align="right">Delivered</TableCell>
											<TableCell align="right">Total</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{(this.state.results && this.state.results.length > 0) && this.state.results.map((product, index) => {
											let awaiting_payment_amount = product?.sold?.awaiting_payment?.amount ?? 0;
											let canceled_amount = product?.sold?.canceled?.amount ?? 0;
											let expired_amount = product?.sold?.expired?.amount ?? 0;
											let paid_amount = product?.sold?.paid?.amount ?? 0;
											let shipped_amount = product?.sold?.shipped?.amount ?? 0;
											let delivered_amount = product?.sold?.delivered?.amount ?? 0;
											total_awaiting_payment_amount += awaiting_payment_amount;
											total_canceled_amount += canceled_amount;
											total_expired_amount += expired_amount;
											total_paid_amount += paid_amount;
											total_shipped_amount += shipped_amount;
											total_delivered_amount += delivered_amount;
											return (
												<TableRow>
													<TableCell>{product.code}</TableCell>
													<TableCell align="right"><NumberFormat value={product?.unit_price ?? 0} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></TableCell>
													<TableCell align="right"><NumberFormat value={awaiting_payment_amount} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></TableCell>
													<TableCell align="right"><NumberFormat value={canceled_amount} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></TableCell>
													<TableCell align="right"><NumberFormat value={expired_amount} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></TableCell>
													<TableCell align="right"><NumberFormat value={paid_amount} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></TableCell>
													<TableCell align="right"><NumberFormat value={shipped_amount} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></TableCell>
													<TableCell align="right"><NumberFormat value={delivered_amount} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></TableCell>
													<TableCell align="right"><NumberFormat value={awaiting_payment_amount + canceled_amount + expired_amount + paid_amount + shipped_amount + delivered_amount} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></TableCell>
												</TableRow>
											)
										})}
										<TableRow>
											<TableCell><b>Grand Total</b></TableCell>
											<TableCell align="right"></TableCell>
											<TableCell align="right"><b><NumberFormat value={total_awaiting_payment_amount} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></b></TableCell>
											<TableCell align="right"><b><NumberFormat value={total_canceled_amount} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></b></TableCell>
											<TableCell align="right"><b><NumberFormat value={total_expired_amount} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></b></TableCell>
											<TableCell align="right"><b><NumberFormat value={total_paid_amount} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></b></TableCell>
											<TableCell align="right"><b><NumberFormat value={total_shipped_amount} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></b></TableCell>
											<TableCell align="right"><b><NumberFormat value={total_delivered_amount} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></b></TableCell>
											<TableCell align="right"><b><NumberFormat value={total_awaiting_payment_amount + total_canceled_amount + total_expired_amount + total_paid_amount + total_shipped_amount + total_delivered_amount} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /></b></TableCell>
										</TableRow>
									</TableBody>
								</Table>
							</TableContainer>
						</div>
						<div style={{ padding: 10 }}>
							<BlueButton disabled={this.state.isLoadingXlsx} loading={this.state.isLoadingXlsx} onClick={this.handleXlsx} width={240} text="Unduh Detail Transaksi" />
						</div>
					</div>
				</div>
			</ThemeProvider>
		)
	}
}

export default Dashboard
